<template>
    <div class="container">  
        <v-layout row wrap style="text-align: center; padding: 15px; border-radius: 12px; background-color: #212121">
            <v-flex style="font-size: 19px;" xs12 mt-2>
                Client Stats (demo data)
            </v-flex>
            <v-flex xs12>
                <hr style="margin: 15px 20px 20px 20px; border-color: #e2e2e2;">
            </v-flex>
            <v-flex sm3>
                Clients: {{ stats.clients }}
            </v-flex>
            <v-flex sm3>
                Essential: {{ stats.essential }}
            </v-flex>
            <v-flex sm3>
                Branded: {{ stats.branded }}
            </v-flex>
            <v-flex sm3>
                Enterprise: {{ stats.enterprise }}
            </v-flex>
            <v-flex xs12>
                <hr style="margin: 20px; border-color: #e2e2e2;">
            </v-flex>
            <v-flex xs12>
                <chartjs-line :width="300" :height="300" :labels="labels" :datasets="datasets" :option="options" :bind="true"/>
            </v-flex>
        </v-layout>      
    </div>
</template>
<script>
import db from '../firebase/init.js'
export default {
    name: 'ClientStats',
    data(){
        return {
            stats: {},
            labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
            datasets: [ 
                {
                    label: "Essential",
                    fill: false,
                    backgroundColor: '#a74545',
                    borderColor: '#a74545',
                    hidden: true,
                    data: [0, 0, 0, 0, 0, 1, 2]
                },  
                {
                    label: "Enterprise",
                    fill: false,
                    backgroundColor: '#45a766',
                    borderColor: '#45a766',
                    hidden: true,
                    data: [4, 5, 5, 5, 5, 5, 5]
                },
                {
                    label: "Branded",
                    fill: false,
                    backgroundColor: 'rgb(136, 83, 174)',
                    borderColor: 'rgb(136, 83, 174)',
                    hidden: true,
                    data: [0, 0, 2, 5, 7, 8, 9]
                    },
                {
                    label: "Clients",
                    fill: true,
                    backgroundColor: '#e2e2e2',
                    borderColor: '#e2e2e2',
                    data: [4, 5, 7, 10, 12, 14, 16]
                }
            ],
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        stacked: false,
                        ticks: {
                            fontColor: "#e2e2e2",
                            fontSize: 10,
                            stepSize: 1,
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true,
                            color: "#424242"
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            fontColor: "#e2e2e2",
                            fontSize: 10,
                            stepSize: 1,
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true,
                            color: "#424242"
                        }
                    }]
                },
                animation: {
                    duration: 750,
                },
                legend: {
            labels: {
                fontColor: "#e2e2e2",
                fontSize: 11
            }
        }

            }
        }
    },
    mounted(){
        // firebase.firestore().collection('stats').doc('client-stats').get()
        // .then(doc => {
        //     this.stats = doc.data()
        // })
    }
}
</script>
<style>
.chart-container {
  position: relative;
  margin: auto;
  height: 80vh;
  width: 80vw;
}
hr{ 
  height: 1px;
  color: rgb(94, 94, 94);
  background-color: rgb(94, 94, 94);
  border: none;
}
</style>
